import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { TopMenuEntry } from './submenu-model';

@Injectable({ providedIn: 'root' })
export class SubmenuStateService {

    private readonly active$ = new BehaviorSubject<TopMenuEntry | null>(null);

    /** Currently open top-level group, or null when collapsed. */
    activeEntry(): Observable<TopMenuEntry | null> {
        return this.active$.asObservable();
    }

    snapshot(): TopMenuEntry | null {
        return this.active$.value;
    }

    open(entry: TopMenuEntry): void {
        this.active$.next(entry);
    }

    close(): void {
        this.active$.next(null);
    }
}
